import axios from "axios";
import { useAuth } from "../../global-components/src";
import { useMessage } from "../../global-components/src";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { PACOCA_API_URL } from "../../global-components/src/utils/vars";
import Spinner from "../../global-components/src/components/spinner/spiner";
import { errorMessage } from "../../global-components/src/utils/text";


interface FormVerifyEmailProps {
    onSend?: () => void;
}


const FormVerifyEmail: React.FC<FormVerifyEmailProps> = ({ onSend }) => {
    const [loadingSendEmailValidation, setLoadingSendEmailValidation] = useState(false);
    const { user, setUser, isAuthenticated, token } = useAuth();
    const { setMessage } = useMessage();
    const { t } = useTranslation();

    const resendVerificationEmail = async () => {
        const lastRequestTime = localStorage.getItem("lastVerifyEmailRequest");
        const now = Date.now();
        const cooldownTime = 60 * 1000; // 1 minuto (ajuste conforme necessário)

        if (lastRequestTime && now - parseInt(lastRequestTime) < cooldownTime) {
            setMessage(t("emailVerification.cooldown"), "warning", t("emailVerification.waitTitle"));
            return;
        }

        try {
            setLoadingSendEmailValidation(true);
            const response = await axios.post(`${PACOCA_API_URL}/email/verification-notification`, {}, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            });

            const data = response.data;
            const message = data.message || t("emailVerification.sentFallback");
            const title = data.title || null;
            const type = data.type_message || "success";
            setMessage(message, type, title)

            if (type === "warning") {
                setUser(prevUser => {
                    if (!prevUser) return prevUser; // Evita erro se prevUser for null
                    return {
                        ...prevUser,
                        email_verified_at: new Date() // Agora é um objeto Date válido
                    };
                });
            }


            localStorage.setItem("lastVerifyEmailRequest", now.toString()); // Salva o tempo da última solicitação
        } catch (err: any) {
            const type = err?.response?.data?.type_message || "error";
            const messageError = errorMessage(err)
            setMessage(messageError, type)
            console.error('Erro:', err);
        } finally {
            if (onSend)
                onSend()
            setLoadingSendEmailValidation(false);
        }
    };

    return (

        <>
            {user && !user?.email_verified_at && isAuthenticated ? (
                // <div className="card card-post card-verify-email-button" style={{margin: 0}}>
                <button disabled={loadingSendEmailValidation} className="btn-sm btn btn-blue w-100" onClick={() => resendVerificationEmail()}>
                    {loadingSendEmailValidation ? (
                        <Spinner />
                    ) : (
                        <>{t("emailVerification.sendButton")}</>
                    )}
                </button>
                // </div>
            ) : null}
        </>

    );
};

export default FormVerifyEmail;
